AFRAME.registerComponent('watchlist-confirmation-popup', {
    init: function() {
        this.config = {};
        this.el.setAttribute('visible', false);
        this.el.setAttribute('scale', '0 0 0');

        this.el.sceneEl.addEventListener('theme-changed', () => {
            if (this.el.getAttribute('visible')) {
                this.render();
            }
        });
    },

    setup: function(config) {
        this.config = config;
    },

    open: function() {
        this.render();
    },

    close: function() {},

    render: function() {
        this.el.innerHTML = '';
        const isLight = (typeof getCacheItem === 'function' && getCacheItem('mainSettings')?.themeMode === 'Light');
        const bgColor = isLight ? '#F5F5F5' : '#111';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';

        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('width', 1.43);
        bg.setAttribute('height', 0.5);
        bg.setAttribute('position', '-0.715 -0.25 0');
        bg.setAttribute('color', bgColor);
        bg.setAttribute('radius', 0.02);
        this.el.appendChild(bg);

        const title = document.createElement('a-troika-text');
        title.setAttribute('value', this.config.title || 'Confirm');
        title.setAttribute('font-size', 0.045);
        title.setAttribute('color', txtColor);
        title.setAttribute('position', '0 0.16 0.01');
        title.setAttribute('anchor', 'center');
        this.el.appendChild(title);

        const msg = document.createElement('a-troika-text');
        msg.setAttribute('value', this.config.message || '');
        msg.setAttribute('font-size', 0.035);
        msg.setAttribute('color', '#AAA');
        msg.setAttribute('position', '0 0.05 0.01');
        msg.setAttribute('anchor', 'center');
        msg.setAttribute('width', 1.3);
        msg.setAttribute('align', 'center');
        this.el.appendChild(msg);

        const buttons = document.createElement('a-entity');
        buttons.setAttribute('position', '0 -0.15 0.02');
        this.el.appendChild(buttons);

        if (this.config.leftBtnText) {
            const leftBtn = document.createElement('a-entity');
            leftBtn.setAttribute('position', '-0.25 0 0');
            leftBtn.setAttribute('ui-button', {
                label: this.config.leftBtnText,
                width: 0.45,
                height: 0.08,
                colorScheme: 'accent',
                type: 'rounded-box',
                depth: 0.02,
                radius: 0.015,
                preferredFontSize: 0.035
            });
            leftBtn.addEventListener('click', () => {
                if (this.config.leftBtnAction) this.config.leftBtnAction();
                window.WatchlistApp.Popup.closeManual('watchlist-confirmation-vr-popup');
            });
            buttons.appendChild(leftBtn);
        }

        const rightBtn = document.createElement('a-entity');
        const rightBtnPos = this.config.leftBtnText ? '0.3 0 0' : '0 0 0';
        rightBtn.setAttribute('position', rightBtnPos);

        rightBtn.setAttribute('ui-button', {
            label: this.config.rightBtnText || 'Cancel',
            width: this.config.leftBtnText ? 0.25 : 0.35,
            height: 0.08,
            colorScheme: 'primary',
            type: 'rounded-box',
            depth: 0.02,
            radius: 0.015,
            preferredFontSize: 0.04
        });
        rightBtn.addEventListener('click', () => {
            if (this.config.rightBtnAction) this.config.rightBtnAction();
            window.WatchlistApp.Popup.closeManual('watchlist-confirmation-vr-popup');
        });
        buttons.appendChild(rightBtn);
    }
});
